<div class="userprofile-container ya-typography">
  <ya-subheader [hasContent]="true">
  </ya-subheader>
  <div class="ya-page-content ya-page-content--webshop ya-page-content--inset">
    <h2 class="header-title"
      [langkey]="deliveryAddressType === AddressType.OldDeliveryAddress ? 'phUserProfileAddress_DeliVeryAddress_Title' : 'phUserProfileAddress_NewDeliveryAddress_Title'">
    </h2>
    <div class="ya-tab-content-wrapper user-address-content-wrapper">
      <div class="ya-form-control-container">
        <ya-dynamicFormFields #dynamicFormFieldsComponent
          *ngIf="addressInputsViewModel && addressInputsViewModel.length>0 && userAddressViewModel"
          [customerFieldsConfig]="addressInputsViewModel" [initialData]="getUserInfoInitialData()">
        </ya-dynamicFormFields>
      </div>
      <div class="ya-button-group-wrapper">
        <div class="ya-button-group-container">
          <ng-container *ngIf="isOnline && isDynamicFormGroupValid() then activeButton else deactiveButton">
          </ng-container>
          <ng-template #activeButton>
            <div class="ya-button-container">
              <button mat-flat-button (click)="saveUserInfo()">
                <span langkey="phUserProfileAddress_Save_User_Info"></span>
              </button>
            </div>
          </ng-template>
          <ng-template #deactiveButton>
            <div class="ya-button-container"> <span (click)="markAllFieldsAsTouched()">
                <button mat-flat-button disabled><span langkey="phUserProfileAddress_Save_User_Info"></span></button>
              </span></div>
          </ng-template>
          <ng-container *ngIf="deliveryAddressType === AddressType.OldDeliveryAddress">
            <div class="ya-webshop-button-container">
              <button mat-stroked-button (click)="deleteAddress()">
                <span langkey="phUserProfileAddress_Delete_Address_Button"></span>
              </button>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>